import {
  ReadBillByIdRequest,
  ReadBillsByEntityRequest,
  ReadInvoicesByEntityRequest,
  ReadInvoiceByIdRequest,
} from '@eigtech/invoicing-types'

export const invoicingBasePath = 'invoicing'

export const invoiceQueryKeys = {
  all: () => ['invoice'],
  list: ({ entityId }: ReadInvoicesByEntityRequest) => [
    ...invoiceQueryKeys.all(),
    entityId,
    'list',
  ],
  details: ({ entityId }: ReadInvoicesByEntityRequest) => [
    ...invoiceQueryKeys.all(),
    entityId,
    'details',
  ],
  detail: ({ entityId, invoiceId }: ReadInvoiceByIdRequest) => [
    ...invoiceQueryKeys.all(),
    entityId,
    'details',
    invoiceId,
  ],
}

export const billQueryKeys = {
  all: () => ['bill'],
  list: ({ entityId }: ReadBillsByEntityRequest) => [...billQueryKeys.all(), entityId, 'list'],
  details: ({ entityId }: ReadBillsByEntityRequest) => [
    ...billQueryKeys.all(),
    entityId,
    'details',
  ],
  detail: ({ entityId, billId }: ReadBillByIdRequest) => [
    ...billQueryKeys.all(),
    entityId,
    'details',
    billId,
  ],
}
